import controller from './rule.controller';

const template = require('./rule.html');

export default {
    bindings: {
        rule: '<'
    },
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/common/rule/rule.component.js